import React from 'react'
import Header from './components/header'
import Main from './components/main'
import Info from './components/info'
import { IntlProvider } from 'react-intl'
import { getMessages } from './locale/_i18n'
import './App.css'

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      aside_active: false,
      info_active: false,
      locale: navigator.language
    }
    
    this.setAsideActive = this.setAsideActive.bind(this)
    this.setInfoActive = this.setInfoActive.bind(this)
    this.setLanguage = this.setLanguage.bind(this)
    
    document.addEventListener('click', (e) => {
      let name = e.target.className
      if (!name.match(/.*aside.*/) && !name.match(/.*lang.*/)) {
        this.setAsideActive(false)
      }
      if (name.match(/.*info.*/)) {
        this.setState({info_active: false})
      }
    })
  }

  render() {
    return (
      <IntlProvider locale="en-US" messages={getMessages(this.state.locale)}>
        <div className='app'>
          <Header locale={this.state.locale}
            handleAsideClick = {this.setAsideActive}
            handleInfoClick = {this.setInfoActive}
            handleLangClick = {this.setLanguage}
          />
          <Main locale={this.state.locale}
            aside={{active: this.state.aside_active, handleClose: this.setAsideActive}}
          />
          <Info info={{active: this.state.info_active}}/>
        </div>
      </IntlProvider>
    )
  }

  setAsideActive(active) {
    active === 'reverse'
    ? this.setState({aside_active: !this.state.aside_active})
    : this.setState({aside_active: active})
  }
  setInfoActive(active) {
    this.setState({info_active: active})
  }
  setLanguage(lang) {
    this.setState({locale: lang})
  }
}

export default App